import React from "react";

export const CustomActions = ({handleClose, disabledCondition, triggerEvent, textFirstButton, textSecondButton, classNameFirstButton, classNameSecondButton}) => {
    return (
        <>
            <button onClick={handleClose} className={classNameFirstButton}>
                {textFirstButton}
            </button>
            <button
                style={{backgroundColor: disabledCondition ? 'var(--disabledunselected-normal-color)' : 'var(--link-normal-color)'}}
                disabled={disabledCondition}
                onClick={triggerEvent}
                className={classNameSecondButton}
                type='submit'
            >
                {textSecondButton}
            </button>
        </>
    );
}